"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BusinessLabelToJSON = exports.BusinessLabelFromJSONTyped = exports.BusinessLabelFromJSON = void 0;
function BusinessLabelFromJSON(json) {
    return BusinessLabelFromJSONTyped(json, false);
}
exports.BusinessLabelFromJSON = BusinessLabelFromJSON;
function BusinessLabelFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'key': json['key'],
        'value': json['value'],
    };
}
exports.BusinessLabelFromJSONTyped = BusinessLabelFromJSONTyped;
function BusinessLabelToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'key': value.key,
        'value': value.value,
    };
}
exports.BusinessLabelToJSON = BusinessLabelToJSON;
